// @ts-nocheck
import React, { useEffect, useState } from 'react'
import { uniqueId, isEmpty, isString } from 'lodash'
// Data
import { Chip, Stack } from '@mui/material'
import Autocomplete from '@mui/material/Autocomplete'
import { Forms } from '../schema'
import TextField from './TextField'
// Assets
import './_Select.scss'
import { events } from '@ggs/utils'

/**
 * Formik needs the value as flat string so we transform the array to comma separated value.
 * @param {Array<string>} selectedOption
 * @return {string}
 */
const flatFormikValue = (selectedOption = []) => {
  return (selectedOption || []).join(',')
}

/**
 * MUI multi options needs to be represented as array so we convert flat Formik values to array.
 * @param {string} formikValue
 * @return {Array<string>}
 */
const parseFormikValue = (formikValue) => {
  return (formikValue || '').split(',') || []
}

const MultiOptionSelect = (props) => {
  const { className, name, onChange, freeSolo = false, value: formikValue } = props
  const { style = '', label = '', placeholder = '', options = [] } = props
  const selectId = uniqueId(`mui-select-${style}-`)
  const [selectedValue, setSelectedValue] = useState(() => {
    return isEmpty(formikValue) ? [] : parseFormikValue(formikValue)
  })

  const handleChange = (e, option) => {
    // console.log('SelectOption:', option)
    setSelectedValue(option)
    const synthEvent = events.syntheticInputEvent(name, { value: flatFormikValue(option) })
    onChange(synthEvent)
  }

  useEffect(() => {
    if (isEmpty(selectedValue) && isString(formikValue) && !isEmpty(formikValue)) {
      const value = parseFormikValue(formikValue)
      setSelectedValue(value)
    }
  }, [formikValue])

  const reset = () => {
    handleChange(new Event('change'), { value: [] })
  }

  return (
    <>
      <Stack>
        <Autocomplete
          className={`${className} form-field__autocomplete`}
          freeSolo={freeSolo}
          id={selectId}
          multiple={true}
          onChange={handleChange}
          options={options.map((option) => option.label)}
          value={selectedValue}
          renderTags={(value = [], getTagProps) => {
            return value.map((option, index) => (
              <Chip
                key={`option-${index}`}
                variant="outlined"
                label={option}
                {...getTagProps({ index })}
              />
            ))
          }}
          renderInput={(params) => (
            <TextField {...params} variant="filled" label={label} placeholder={placeholder} />
          )}
        />
      </Stack>
      <button
        className="form-field__reset"
        data-name={name}
        type="button"
        aria-hidden
        onClick={reset}
      />
    </>
  )
}

export default MultiOptionSelect
